import React from 'react';
import { useIntl } from 'react-intl';
import './styles.scss';

const TimeOfDayDetails = () => {
  const intl = useIntl();
  return (
    <div>
      <div className="subtitle">
        {intl.formatMessage({
          id: 'rs.timeOfDay',
          defaultMessage:
            'Time-of-Day rate (5-8 p.m.) overview (standard rate for residential customers)',
        })}
      </div>

      <div className="text">
        <ul>
          <li>
            {intl.formatMessage({
              id: 'rs.timeOfDay.b1',
              defaultMessage:
                'The price for electricity varies based on the time of day you use it.  ',
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: 'rs.timeOfDay.b2',
              defaultMessage:
                'Save on your electricity bill when you conserve energy during peak hours (weekdays from 5 p.m. to 8 p.m.). ',
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: 'rs.timeOfDay.b3',
              defaultMessage:
                'Helps reduce grid strain and support a cleaner environment when shifting energy use to off-peak hours. By shifting the time you use electricity, you can save on your bill and reduce the impact on our environment.',
            })}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TimeOfDayDetails;
